import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => {
    setClick(!click);
    console.log("Click state is now: ", !click);
  };

  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  useEffect(() => {
    const showButton = () => {
      // your logic here
    };

    window.addEventListener('resize', showButton);

    return () => {
      window.removeEventListener('resize', showButton);
    };
  }, []);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
            BJDG
            <FontAwesomeIcon icon={faGlobe} />
          </Link>

          <div className='menu-icon' onClick={handleClick}>
            <FontAwesomeIcon icon={faBars} />
          </div>

          <ul className={click ? 'nav-menu active' : 'nav-menu'}>

            <li className='nav-item'>
              <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                Home
              </Link>
            </li>

            <li className='nav-item'>
              <Link to='/journey' className='nav-links' onClick={closeMobileMenu}>
                Journey
              </Link>
            </li>
            
            <li className='nav-item'>
              <Link to='/research' className='nav-links' onClick={closeMobileMenu}>
                Research
              </Link>
            </li>

            <li className='nav-item'>
              <Link to='/projects' className='nav-links' onClick={closeMobileMenu}>
                Projects
              </Link>
            </li>

            <li>
              <Link to='/kitesurfing' className='nav-links-mobile' onClick={() => {console.log("Kitesurfing clicked"); closeMobileMenu();}}>
                Kitesurfing
              </Link>
            </li>


          </ul>
          {button && <Button buttonStyle='btn--outline' path='/kitesurfing'>Kitesurfing</Button>}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
